"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeNormalizer = exports.normalizeEscapes = exports.replaceAll = exports.prepareForComparison = void 0;
const prepareForComparison = (text, opts = {
    stripDiacritics: true,
    stripPunctuation: /[\.\,\/#!@\$%&;:<>\(\)~\^\{\}\-\+\\\`\´\\\"\[\]]/g,
    caseInsensitive: true,
    stripSpaces: true,
}) => {
    if (!text)
        return text;
    let val = text;
    if (opts.stripDiacritics) {
        val = val
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }
    if (opts.stripPunctuation) {
        val = val.replace(opts.stripPunctuation, '');
    }
    if (opts.stripSpaces) {
        val = val.replace(/\s/g, '');
    }
    if (opts.caseInsensitive) {
        val = val.toLocaleLowerCase();
    }
    return val;
};
exports.prepareForComparison = prepareForComparison;
function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
const replaceAll = (str, find, replace) => {
    const re = new RegExp(escapeRegExp(find), 'g');
    return str.replace(re, replace);
};
exports.replaceAll = replaceAll;
const normalizeEscapes = (str, find, replace) => {
    return str.split(find).join(replace);
};
exports.normalizeEscapes = normalizeEscapes;
const localeNormalizer = (locale) => (0, exports.replaceAll)(locale, '-', '_').trim().toLocaleLowerCase();
exports.localeNormalizer = localeNormalizer;
